import { ReactNode } from 'react';

import { UserPermissions } from 'types';

import usePermissions from '../../hooks/usePermissions';

import { useInviteToken } from './useInviteToken';

const RequirePermissions = ({
  permissions = [],
  checkAllPermissions = true,
  allowInviteToken = false,
  children,
}: {
  permissions: UserPermissions[];
  checkAllPermissions?: boolean;
  allowInviteToken?: boolean;
  children: ReactNode;
}) => {
  const userPermissions = usePermissions();
  const { isInviteToken } = useInviteToken();

  if (allowInviteToken && isInviteToken) {
    return children;
  }

  let show = false;
  if (checkAllPermissions) {
    show = permissions.every((permission) => userPermissions.includes(permission));
  } else {
    show = permissions.some((permission) => userPermissions.includes(permission));
  }

  return show ? children : null;
};

export default RequirePermissions;
